import { render, staticRenderFns } from "./ChooseExample.vue?vue&type=template&id=015ca9af&"
import script from "./ChooseExample.vue?vue&type=script&lang=js&"
export * from "./ChooseExample.vue?vue&type=script&lang=js&"
import style0 from "./ChooseExample.vue?vue&type=style&index=0&id=015ca9af&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports